// import Supports from "../utils/supports";
import { getFingerprintId } from "./initfingerprint";

let DEVICE_FINGERPRINT = null;

async function __getDeviceFingerprint__() {
  if (DEVICE_FINGERPRINT) return DEVICE_FINGERPRINT;

  // if (Supports.worker) {
  //   const worker = new Worker(`${process.env.SCRIPTS_BASE}/workers/fingerprint.js`);

  //   return new Promise((resolve) => {
  //     worker.postMessage(null);
  //     worker.onmessage = function(evt) {
  //       return evt.data
  //         ? resolve(DEVICE_FINGERPRINT = evt.data)
  //         : worker.postMessage(null);
  //     };
  //   }).finally(() => {
  //     worker.terminate();
  //   });
  // }

  // return null

    const result = await getFingerprintId();

    return new Promise((resolve) => {
      result !== null
        ? resolve(DEVICE_FINGERPRINT = result)
        : resolve(DEVICE_FINGERPRINT = null);
    })
}

export { DEVICE_FINGERPRINT };

export default function getDeviceFingerprint() {
  return Promise.resolve(__getDeviceFingerprint__());
};
